<modal
  [modalId]="'device-form'"
  [modalSize]="'md'"
  (close)="modalCleanup()">
  <h3 class="d-inline text-capitalize" modal-title>{{deviceId == null ? 'Add Device' : 'Edit Device'}}</h3>
  <div class="modal-inner h-100 pt-3" modal-inner>
    <form class="d-flex flex-column" id="form" [formGroup]="form" autocomplete="off">
      <div class="custom-field my-2">
        <label class="custom-field-label" for="device-serial-number">Serial Number</label>
        <custom-text-input inputId="device-serial-number" formControlName="serialNumber" placeholder=""
          [readonly]="deviceId != null" [errorMessages]="serialNumberErrors"></custom-text-input>
      </div>

      <div class="custom-field my-2">
        <label class="custom-field-label">Customer</label>
        <synx-dropdown formControlName="customerId" [selectOptions]="customerOptions" [fullWidth]="true"
          [placeholder]="'Select a customer'"></synx-dropdown>
        <synx-errors label="Please select a customer for the device"
          [show]="form.controls['customerId'].invalid && form.controls['customerId'].touched"></synx-errors>
      </div>

      <div class="custom-field-row my-2">
        <div class="custom-field">
          <label class="custom-field-label">Asset Type</label>
          <synx-dropdown formControlName="assetTypeId" [selectOptions]="assetTypeOptions" [fullWidth]="true"
            [placeholder]="'None'"></synx-dropdown>
        </div>
        <button type="button" class="custom-icon-button" (click)="openAssetTypeExpander(); $event.stopPropagation()" tabindex="-1">
            <i class="fas fa-lg fa-plus"></i>
        </button>
      </div>
      <lookup-form [lookupName]="'Asset Type'" [listTitle]="'Asset Types'" [controllerName]="'AssetType'"
        *ngIf="addingAssetType" (sendCloseEvent)="assetTypeExpanderClosed($event)" (sendDeleteEvent)="assetTypeDeleted()">
      </lookup-form>

        <div class="custom-field my-2">
          <label class="custom-field-label" for="device-fleet-id">Asset ID</label>
          <custom-text-input inputId="device-fleet-id" formControlName="fleetId" placeholder=""
            [errorMessages]="fleetIdErrors"></custom-text-input>
        </div>

        <div class="custom-field my-2">
            <label class="custom-field-label" for="device-api-key">API Key</label>
            <custom-text-input inputId="device-api-key" formControlName="APIKey" placeholder=""></custom-text-input>
        </div>

        <div class="custom-field my-2">
            <label class="custom-field-label" for="device-asset-group-path">Asset Group Path</label>
            <custom-text-input inputId="device-asset-group-path" formControlName="assetGroupPath" placeholder=""></custom-text-input>
        </div>

        <div class="labelled-slider simple-slider">
          <span>Enabled:</span>
          <label class="switch">
            <input type="checkbox" formControlName="enabled">
            <span class="slider round"></span>
          </label>
        </div>

        <div class="labelled-slider simple-slider">
          <span>Recording Map Upload:</span>
          <label class="switch">
            <input type="checkbox" formControlName="enableRecordingMapRequest">
            <span class="slider round"></span>
          </label>
        </div>

        <div class="labelled-slider simple-slider">
          <span>Camera Snapshots Upload:</span>
          <label class="switch">
            <input type="checkbox" formControlName="enableCamerasSnapshotRequest">
            <span class="slider round"></span>
          </label>
        </div>

      <hr class="my-2" />

      <div class="modal-button-row mt-3 px-3 justify-content-between" *ngIf="deviceId != null">
        <button
          class="custom-button custom-button-warn"
          id="delete"
          type="button"
          (click)="deleteDevice()"
          [disabled]="requestInProgress">
          Delete
        </button>
        <button class="custom-button custom-button-flat" id="edit" (click)="submitForm()" [disabled]="requestInProgress">
          Save Changes
        </button>
      </div>

      <div class="modal-button-row mt-3 px-3 justify-content-end" *ngIf="deviceId == null">
        <button class="custom-button custom-button-flat" id="add" (click)="submitForm()" [disabled]="requestInProgress">Add Device</button>
      </div>
    </form>
  </div>
</modal>
